import { Service } from '@roc/feature-app-core';
import { LoanService } from '@roc/feature-loans';
import { isMobileApp, isNil } from '@roc/feature-utils';

const url = {
  LOANS: '/api/v1/loan/unified/getLoans',
  CUSTOM_STATUSES: '/platform-api/v1/los-loans/loans/statuses/custom/merged',
  PIPELINE_LOANS: '/api/v1/loan/unified/getPipelineLoans',
  QUOTE_LOANS: '/api/v1/loan/unified/getLoanQuotes',
  DRAWS: '/api/v1/loan/unified/getDraws',
  EXTENSIONS: '/api/v1/loan/unified/getExtensions',
  PAYOFFS: '/api/v1/loan/unified/getPayoffs',
  BORROWER_DRAWS: '/api/v1/loan/unified/borrowerLoans/getDraws',
  BORROWER_EXTENSIONS: '/api/v1/loan/unified/borrowerLoans/getExtensions',
  BORROWER_PAYOFFS: '/api/v1/loan/unified/borrowerLoans/getPayoffs',
};

export class UnifiedLoanService extends Service {
  getCustomStatuses(lenderId: number) {
    return this.get(url.CUSTOM_STATUSES, { lenderId });
  }

  getMyLoans(
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object,
    externalStatus: string,
    offsets: number[],
    source: string
  ) {
    return this.get(
      url.LOANS,
      {
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
        externalStatus,
        offsets: offsets.join(','),
        source,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  getMyQuoteLoans(
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object,
    externalStatus: object,
    offsets: number[],
    source: string
  ) {
    return this.get(
      url.QUOTE_LOANS,
      {
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
        externalStatus,
        offsets: offsets.join(','),
        source,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  getMyPipelineLoans(
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object,
    externalStatus: object,
    offsets: number[],
    source: string
  ) {
    return this.get(
      url.PIPELINE_LOANS,
      {
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
        externalStatus,
        offsets: offsets.join(','),
        source,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  getMyDraws(
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object,
    externalStatus: object,
    offsets: number[],
    source: string
  ) {
    return this.get(
      url.DRAWS,
      {
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
        externalStatus,
        offsets: offsets.join(','),
        source,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  getMyExtensions(
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object,
    externalStatus: object,
    offsets: number[],
    source: string
  ) {
    return this.get(
      url.EXTENSIONS,
      {
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
        externalStatus,
        offsets: offsets.join(','),
        source,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  getMyPayoffs(
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object,
    externalStatus: object,
    offsets: number[],
    source: string
  ) {
    return this.get(
      url.PAYOFFS,
      {
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
        externalStatus,
        offsets: offsets.join(','),
        source,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  getBorrowerDraws(
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object,
    externalStatus: object,
    offsets: number[],
    source: string
  ) {
    return this.get(
      url.BORROWER_DRAWS,
      {
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
        externalStatus,
        offsets: offsets.join(','),
        source,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  getBorrowerExtensions(
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object,
    externalStatus: object,
    offsets: number[],
    source: string
  ) {
    return this.get(
      url.BORROWER_EXTENSIONS,
      {
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
        externalStatus,
        offsets: offsets.join(','),
        source,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  getBorrowerPayoffs(
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object,
    externalStatus: object,
    offsets: number[],
    source: string
  ) {
    return this.get(
      url.BORROWER_PAYOFFS,
      {
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
        externalStatus,
        offsets: offsets.join(','),
        source,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }
}
